import './style.scss'
import { observeVideoPlayback } from '../../../js/utils/video-playback'

export default !function () {
  const block = document.querySelector('.process-v5')

  if (!block) {
    return
  }

  const videos = [...block.querySelectorAll('.process-v5__media--video video')]

  videos.forEach((video) => {
    observeVideoPlayback(video)
  })
}()
